import { lazy } from 'react'

const CHUNK_RELOAD_KEY = 'lazy-chunk-reload'

export const lazyWithRetry = (componentImport, chunkName = 'chunk') =>
  lazy(async () => {
    try {
      const module = await componentImport()
      sessionStorage.removeItem(CHUNK_RELOAD_KEY)
      return module
    } catch (error) {
      const reloadKey = `${CHUNK_RELOAD_KEY}:${chunkName}`
      const hasReloaded = sessionStorage.getItem(reloadKey) === '1'

      if (!hasReloaded) {
        sessionStorage.setItem(reloadKey, '1')
        window.location.reload()
        return { default: () => null }
      }

      sessionStorage.removeItem(reloadKey)
      throw error
    }
  })
